import moment from 'moment';

// Mengelompokkan baris flat UserActivityLog (hasil API /activitylog/me/ atau
// /activitylog/admin/log/) jadi kartu per (nomor_polisi + tanggal kalender) -
// murni di frontend, backend/database TIDAK berubah sama sekali (lihat
// diskusi rencana 2026-10-17). Baris tanpa nomor_polisi (mis. login) tetap
// berdiri sendiri, tidak ikut dikelompokkan.
//
// Catatan: pengelompokan ini HANYA berlaku di dalam satu halaman/page hasil
// fetch yang sudah dipaging backend - kalau event untuk nopol+tanggal yang
// sama kebetulan terpotong di 2 halaman berbeda, akan muncul sbg 2 kartu
// terpisah (batasan yang disadari, bukan bug - konsekuensi dari keputusan
// "pengelompokan di level baca, bukan tulis" supaya paging backend tetap
// sederhana/aman).
//
// Return: array campuran, urutan TERBARU dulu (konsisten konvensi list):
//   { type: 'single', key, row }
//   { type: 'group', key, nomor_polisi, tanggal, rows: [...asc by time], sortTime }
export function groupActivityByNopolTanggal(rows) {
	const groupMap = new Map();
	const items = [];

	(rows || []).forEach((row) => {
		if (!row.nomor_polisi) {
			items.push({ type: 'single', key: `single-${row.id}`, row, sortTime: row.timestamp });
			return;
		}
		const tanggal = moment(row.timestamp).format('YYYY-MM-DD');
		const key = `${row.nomor_polisi}|${tanggal}`;
		let group = groupMap.get(key);
		if (!group) {
			group = {
				type: 'group', key, nomor_polisi: row.nomor_polisi, tanggal,
				rows: [], sortTime: row.timestamp,
			};
			groupMap.set(key, group);
			items.push(group);
		}
		group.rows.push(row);
		if (new Date(row.timestamp) > new Date(group.sortTime)) group.sortTime = row.timestamp;
	});

	items.forEach((it) => {
		if (it.type === 'group') it.rows.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
	});
	items.sort((a, b) => new Date(b.sortTime) - new Date(a.sortTime));

	return items;
}

// Nama pemilik "representatif" utk header kartu - ambil dari event PALING
// BARU di grup yang detail-nya punya nama_pemilik, fallback ke yang lebih
// lama kalau yang terbaru tidak ada.
// FIX (2026-10-17): path sebelumnya baca detail.nama_pemilik langsung -
// sejak detail dikategorikan (identitas_pemilik/identitas_kendaraan/
// detail_nominal), field itu pindah ke detail.identitas_pemilik.nama_pemilik
// - lupa diikutkan saat refactor backend, bikin nama pemilik selalu kosong
// di header kartu. Lihat diskusi rencana 2026-10-17.
export function ambilNamaPemilikGrup(group) {
	for (let i = group.rows.length - 1; i >= 0; i--) {
		const d = group.rows[i].detail;
		const nama = d && d.identitas_pemilik && d.identitas_pemilik.nama_pemilik;
		if (nama) return nama;
	}
	return null;
}

// IP address "representatif" utk header kartu - ambil dari event PALING
// BARU di grup yang py ip_address terisi. Field ini di TOP-LEVEL baris
// (bukan di dalam `detail`), jadi tidak kena masalah yang sama spt di atas.
export function ambilIpGrup(group) {
	for (let i = group.rows.length - 1; i >= 0; i--) {
		if (group.rows[i].ip_address) return group.rows[i].ip_address;
	}
	return null;
}
